<template>
  <el-select
    v-model="selected"
    placeholder="Selecione  uma opção"
    @change="update()"
  >
    <el-option
      v-for="row of couriers"
      v-bind:key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { CouriesService } from "@/services/customers/couries.services";
export default {
  name: "CouriersList",
  props: ["current"],
  data: function () {
    return {
      couriers: [],
      selected: "",
    };
  },
  watch: {
    current: function (v) {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    fetchCouriers() {
      const vm = this;
      CouriesService.list()
        .then((response) => {
          vm.couriers = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchCouriers();
  },
};
</script>